import React, { useState } from 'react'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { toast } from "react-toastify";
import { Get_Geo_Details } from '../../../../api/third_party_api/Third_Party_Api';
import { THIRD_PARTY_API_KEY, THIRD_PARTY_USER_ID } from '../../../../config/Config';
import debounce from 'lodash.debounce';
import { isAlphabetical } from '../../../validation/Validation';
import { Get_Basic_Kundli_PDF } from '../../../../api/global/Global';

const Free_Get_Kundli_Form = () => {
    // State to manage form inputs
    const [geo_Data, set_geo_Data] = useState([])
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null);
    const [is_submitting, set_Is_Submitting] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        gender: "",
        birthDateTime: "",
        birthPlace: "",
    });

    const [errorMessage, setErrorMessage] = useState('');


    const Handle_Get_Geo_Location = async () => {
        const user_id = THIRD_PARTY_USER_ID;
        const api_key = THIRD_PARTY_API_KEY;
        const basicAuth = btoa(`${user_id}:${api_key}`);

        const data = {
            place: formData.birthPlace,
            maxRows: 7
        };

        const headers = {
            "Authorization": `Basic ${basicAuth}`,
            "Content-Type": "application/json"
        };

        try {
            const response = await Get_Geo_Details(data, headers);
            if (response?.data?.geonames && response?.data?.geonames?.length > 0) {
                const geoData = response.data.geonames;
                set_geo_Data(response?.data?.geonames)

            }
        } catch (error) {
            console.error("Failed to Get Geo Details:", error.response || error);
        }
    };

    const debouncedHandle_Get_Geo_Location = debounce(Handle_Get_Geo_Location, 500);

    const handleChange = (e) => {
        setErrorMessage("");
        const { name, value } = e.target;
        if (name === "name" && value && !isAlphabetical(value)) {
            setErrorMessage("Name should only contain alphabetic characters");
            return;
        }
        setFormData({
            ...formData,
            [name]: value
        });

        if (name === "birthPlace" && value.length >= 3) {
            debouncedHandle_Get_Geo_Location();
        }
    };

    // Handle selecting a location from the list
    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
        setFormData((prevState) => ({
            ...prevState,
            birthPlace: location?.place_name, // Assuming the response contains a property called 'place_name'
        }));
        set_geo_Data([]); // Clear the geo data list after selection
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name) {
            toast("Please enter the user name ")
            return;
        }
        else if (!formData.gender) {
            toast("Please select your gender")
            return;
        }
        else if (!formData.birthDateTime) {
            toast("Please enter your birth date and time ")
            return;
        }
        else if (!formData.birthPlace) {
            toast("Please enter your birth place ")
            return;
        }
        try {
            set_Is_Submitting(true);
            // Parse datetime-local string → individual parts
            const dt = new Date(formData.birthDateTime);
            const payload = {
                name: formData.name,
                gender: formData.gender.toLowerCase(),
                day: dt.getDate(),
                month: dt.getMonth() + 1,
                year: dt.getFullYear(),
                hour: dt.getHours(),
                min: dt.getMinutes(),
                lat: selectedLocation?.lat ?? 0,
                lon: selectedLocation?.lng ?? 0,
                tzone: selectedLocation?.timezone ?? 5.5,
                place: formData.birthPlace,
                language: "en",
                chart_style: "NORTH_INDIAN",
                footer_link: window.location.origin,
                logo_url: "",
                company_name: "Omens",
                company_info: "",
                domain_url: window.location.origin,
                company_email: "",
                company_landline: "",
                company_mobile: ""
            };
            const response = await Get_Basic_Kundli_PDF(payload);
            if (response?.data?.status && response?.data?.pdf_url) {
                setPdfUrl(response.data.pdf_url);
                toast.success("Kundli generated successfully!");
            } else {
                toast.error("Failed to generate Kundli. Please try again.");
            }
        } catch (error) {
            console.error("Kundli PDF error", error);
            toast.error("An error occurred. Please try again.");
        } finally {
            set_Is_Submitting(false);
        }
    };
    return (
        <div className="kundli_form w-full mt-6">
            <div className="flex flex-wrap w-full">
                <div
                    className="min-[992px]:w-[66.33%] flex min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto pr-6">
                    <div className="bg-white w-full">
                        <h3 className="mb-2 font-semibold text-gray-900 p-4 border-b">Enter Your Birth Details and get
                            free Janam Kundali analysis</h3>
                        <form onSubmit={handleSubmit} method="post">
                            <div className="py-5 pl-6 pr-6">
                                {errorMessage && <p className="text-red-500 text-sm mb-2">{errorMessage}</p>}
                                <div className="input-grid flex space-x-2.5 mb-6">
                                    <div className="w-1/2 h-full">
                                        <div className="input-com">
                                            <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">
                                                Name*
                                            </label>
                                            <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                                                <input
                                                    name="name"
                                                    placeholder="Name"
                                                    className="input-field placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                    type="text"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                />

                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-1/2 h-full">
                                        <div className="input-com">
                                            <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">
                                                Gender
                                            </label>
                                            <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                                                <select
                                                    name="gender"
                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                    value={formData.gender}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="input-grid flex space-x-2.5 mb-6">
                                    <div className="w-1/2 h-full">
                                        <div className="input-com">
                                            <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">
                                                Birth Date and Time Details
                                            </label>
                                            <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                                                <input
                                                    name="birthDateTime"
                                                    placeholder="datetime-local"
                                                    className="input-field w-full placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                    type="datetime-local"
                                                    max={new Date().toISOString().slice(0, 16)}
                                                    value={formData.birthDateTime}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-1/2 h-full">
                                        <div className="input-com">
                                            <label className="input-label capitalize block mb-2 text-qgray text-[13px] font-normal">
                                                Birth Place*
                                            </label>
                                            <div className="input-wrapper border border-qgray-border overflow-hidden relative">
                                                <input
                                                    name="birthPlace"
                                                    placeholder="Birth Place*"
                                                    className="input-field placeholder:text-sm text-sm px-6 text-dark-gray font-normal bg-white focus:ring-0 focus:outline-none h-[50px]"
                                                    type="text"
                                                    value={formData.birthPlace}
                                                    onChange={handleChange}
                                                />
                                                {
                                                    geo_Data?.map((geo_Data_result, index) => {
                                                        return (
                                                            <p key={index} onClick={() => handleLocationSelect(geo_Data_result)}>{geo_Data_result?.place_name}</p>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="input-grid">
                                    <div className="w-full">
                                        <div className="input-com">
                                            <button
                                                type="submit"
                                                disabled={is_submitting}
                                                className="w-[164px] h-[45px] bg-[#9F2225] text-white text-sm disabled:opacity-60"
                                            >
                                                {is_submitting ? 'Generating...' : 'Generate'}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {pdfUrl && (
                                    <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded">
                                        <p className="text-green-700 font-medium mb-2">Your Kundli is ready!</p>
                                        <a
                                            href={pdfUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="inline-block px-6 py-2 bg-[#9F2225] text-white text-sm hover:bg-red-800"
                                        >
                                            Download Kundli PDF
                                        </a>
                                    </div>
                                )}
                            </div>
                        </form>

                    </div>
                </div>
                <div
                    className="bg-white min-[992px]:w-[33.33%] min-[768px]:w-[50%] min-[576px]:w-[50%] max-[420px]:w-full max-[575px]:w-[50%] max-[575px]:mx-auto">
                    <img src={Common_Images_Transport?.janam_kundli} alt="" />
                </div>
            </div>
        </div>
    )
}

export default Free_Get_Kundli_Form